export class AbstractMultiValueDirective {
    constructor() {
        this.state = new Set();
    }
    addValue(value) {
        const values = Array.isArray(value) ? value : [value];
        this.state = new Set([...this.state, ...values]);
        return this;
    }
    serialize() {
        const sources = Array.from(this.state).join(' ');
        return `${this.getDirectiveName()} ${sources};`;
    }
    getMinimumCspVersion() {
        return 1;
    }
}
